import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import HomeLoanOfferView from 'partial/OfferManager/modules/HomeLoanModuleRedesign/HomeLoanOfferView';

export const HomeLoanModuleController = props => {
  const loading = props.globalLoadingFlag;
  if (loading) {
    return <LoadingMask />;
  } else {
    const hlOffers = props?.offers;
    return (
      <HomeLoanOfferView
        creditInfo={props.creditInfo}
        hlOffers={hlOffers}
        {...props}
      />
    );
  }
};
